import React from 'react';
import PropTypes from 'prop-types';

import { ReduxFormField } from 'components';

const ReduxFormHiddenInput = ({ ...rest }) => {
  return <ReduxFormField component="input" type="hidden" {...rest} />;
};

ReduxFormHiddenInput.propTypes = {};
ReduxFormHiddenInput.defaultProps = {};

export default ReduxFormHiddenInput;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormHiddenInput.js